import { Button } from '@kanda-libs/ks-design-library';
import useJobMarkAsFinishedButton from './useJobMarkAsFinishedButton';

const JobMarkAsFinishedButton: React.FunctionComponent = function ({}) {
  const { showButton, onClick, companyIsLoading, isSubmitting } =
    useJobMarkAsFinishedButton();
  if (!showButton) return null;
  return (
    <Button.Text
      id="job-details-mark-as-finished"
      onClick={onClick}
      label="Mark as finished"
      size={40}
      icon="send"
      left
      className="w-full whitespace-nowrap"
      disabled={companyIsLoading || isSubmitting}
    />
  );
};

export default JobMarkAsFinishedButton;
